import React from "react";
import VsPage from "./VsPage";

export default function VsMindfulTrader() {
  return (
    <VsPage
      slug="mindful-trader"
      competitor="Mindful Trader"
      competitorPrice="$47/mo"
      tagline="Mindful Trader is a curated stock-pick subscription with published back-tested returns. Moonbucks is the same category — curated picks — at roughly a third of the price and with a live, ongoing track record instead of a back-test."
      rows={[
        { label: "Curated buy-alert shortlist",                          them: true, us: true },
        { label: "Published historical performance",                    them: "Back-tested", us: "Live, ongoing" },
        { label: "Every alert reviewed by a human",                     them: true, us: true },
        { label: "Public per-trade audit trail",                        them: false, us: true },
        { label: "$10K portfolio simulation you can inspect",           them: false, us: true },
        { label: "Custom scenario picker (your picks, our math)",       them: false, us: true },
        { label: "Discord subscriber channel",                          them: false, us: true },
        { label: "Entry price",                                          them: "$47/mo", us: "$14.99/mo" },
      ]}
      whenThem={[
        "You want a longer-established brand with published back-tests.",
        "You're primarily buying the analyst's reputation from mindfultrader.net.",
      ]}
      whenUs={[
        "You want a live, auditable track record — not a back-test.",
        "You want the same class of curated alerts at a third of the price.",
        "You want to hand-pick which alerts count toward your simulation.",
      ]}
    />
  );
}
